import { ReducerGetter, TypedDispatch } from '..';
import { setIsExpanded } from './favourites';

export const toggleExpandFavourites = (newState?: boolean) => (dispatch: TypedDispatch, getState: ReducerGetter): void => {
    const state = getState();
    const { isExpanded } = state.favouritesReducer;

    dispatch(setIsExpanded(newState ?? !isExpanded));
};
